module.exports = __webpack_public_path__ + "assets/images/clients/17.png";